import { Injectable } from '@angular/core';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root',
})
export class FormatoProductosService {
  constructor(private gqlclient: GraphQLClient) {}

  GetFormatosByCodigo(rutEmpresa, codigoProducto, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $producto_codigo: Decimal) {
            producto_formato {
              obtenerProductosFormatos(filtro: { exacto: { empresa_rut: $empresa_rut, producto_codigo: $producto_codigo, activo: true } }) {
                respuesta {
                  registros {
                    empresa_rut
                    producto_codigo
                    formato_codigo
                    formato_nombre
                    peso_neto
                    volumen
                    fecha_registro
                    cantidad
                    activo
                    formato_codigo_top
                    formato_secundario
                    precio_costo
                  }
                }
              }
            }
          }
        `,
        variables: {
          empresa_rut: rutEmpresa,
          producto_codigo: codigoProducto,
        },
        fetchPolicy: 'no-cache',
      },
      function (response) {
        // const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(
        //   respuesta.data.cliente_proveedor.obtenerSegunFiltro
        // );
        // if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        // } else {
        //   alert(notificacion.mensajes[0].texto);
        // }

        const { mensajes, respuesta } = response.data.producto_formato.obtenerProductosFormatos;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerDescuentoEspecialProducto(
    inputParams: {
      entidad: {
        empresa_rut: number;
        sku: string;
        rut_cliente: number;
        direccion_codigo: number;
      };
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: productoInputType) {
            producto {
              obtenerProductoDescuentoEspCliente(entidad: $entidad) {
                respuesta {
                  monto_descuento
                  producto_codigo
                  descuento_cliente_codigo
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        // const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(
        //   respuesta.data.cliente_proveedor.obtenerSegunFiltro
        // );
        // if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        // } else {
        //   alert(notificacion.mensajes[0].texto);
        // }

        const { mensajes, respuesta } = response.data.producto.obtenerProductoDescuentoEspCliente;
        callback({ mensajes, respuesta });
      }
    );
  }

  GetFormatosCombinacion1(
    inputParams: {
      entidad: {
        empresa_rut: number;
        producto_codigo: number;
      };
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: producto_formatoInputType) {
            producto_formato {
              obtenerFormatoCombinacion1(entidad: $entidad) {
                respuesta {
                  empresa_rut
                  producto_codigo
                  formato_codigo
                  formato_nombre
                  cantidad
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.producto_formato.obtenerFormatoCombinacion1;
        callback({ mensajes, respuesta });
      }
    );
  }

  GetFormatosCombinacion2(
    inputParams: {
      entidad: {
        empresa_rut: number;
        producto_codigo: number;
      };
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: producto_formatoInputType) {
            producto_formato {
              obtenerFormatoCombinacion2(entidad: $entidad) {
                respuesta {
                  empresa_rut
                  producto_codigo
                  formato_codigo
                  formato_nombre
                  cantidad
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.producto_formato.obtenerFormatoCombinacion2;
        callback({ mensajes, respuesta });
      }
    );
  }
}
